import Cookies from 'js-cookie'

let MODEL_E = 'Należy wybrać model';
let KIND_E = 'Należy wybrać rodzaj';
let TYPE_E = 'Należy wybrać typ';
let SIDE_E = 'Należy wybrać burty';
let SLIDEW_E = 'Należy podać wysokość zjeżdżalni';
let TRACKSA_E = 'Należy podać ilość torów';
let SLIDEH_E = 'Należy podać wysokość zjeżdżalni';
let MOUNTING_E = 'Należy wybrać mocowanie';
let SLOPEH_E = 'Należy podać wysokość skarpy';
let SLOPEL_E = 'Należy podać długość skarpy';
let SLOPED_E = 'Należy podać kąt nachylenia skarpy';
let PLATFORMH_E = 'Należy podać wysokość podestu';
let FINISH_E = 'Należy wybrać wykończenie';
let MATERIAL_E = 'Należy wybrać materiał';
let FULLNAME_E = 'Należy podać imię i nazwisko';
let BUSINESSN_E = 'Należy podać nazwę firmy';
let EMAIL_E = 'Należy podać adres e-mail';
let PHONE_E = 'Należy podać numer telefonu';
let ACCEPTANCE_E = 'Należy zaakceptować zgodę na przetwarzanie danych osobowych';
let FORM_ID = '2288'
if(Cookies.get('pll_language') == 'en'){
	MODEL_E = 'You have to choose a model';
	KIND_E = 'Select the type';
	TYPE_E = 'Please select a type';
	SIDE_E = 'Select sides';
	SLIDEW_E = 'Please enter the height of the slide';
	TRACKSA_E = 'Enter the number of tracks';
	SLIDEH_E = 'Please enter the height of the slide';
	MOUNTING_E = 'You must select a mount';
	SLOPEH_E = 'Enter the slope height';
	SLOPEL_E = 'The length of the slope should be entered';
	SLOPED_E = 'Enter the slope angle of the slope';
	PLATFORMH_E = 'Please enter the height of the platform';
	FINISH_E = 'Please select a finish';
	MATERIAL_E = 'You need to select a material';
	FULLNAME_E = 'Please enter your first name and surname';
	BUSINESSN_E = 'You should enter a company name';
	EMAIL_E = 'You must enter an e-mail address';
	PHONE_E = 'You must enter a phone number';
	ACCEPTANCE_E = 'Consent to the processing of personal data must be accepted';
  FORM_ID = '2303'
}else if(Cookies.get('pll_language') == 'de'){
	MODEL_E = 'Bitte wählen Sie ein Modell';
	KIND_E = 'Bitte wählen Sie einen Typ';
	TYPE_E = 'Bitte wählen Sie einen Typ';
	SIDE_E = 'Seiten auswählen';
	SLIDEW_E = 'Bitte geben Sie die Höhe der Folie ein';
	TRACKSA_E = 'Geben Sie die Anzahl der Tracks ein';
	SLIDEH_E = 'Bitte geben Sie die Höhe der Folie ein';
	MOUNTING_E = 'Sie müssen ein Reittier auswählen';
	SLOPEH_E = 'Geben Sie die Steigungshöhe ein';
	SLOPEL_E = 'Die Länge der Steigung soll eingegeben werden';
	SLOPED_E = 'Geben Sie den Neigungswinkel der Neigung ein';
	PLATFORMH_E = 'Bitte geben Sie die Höhe der Plattform ein';
	FINISH_E = 'Bitte wählen Sie ein Ende';
	MATERIAL_E = 'Sie müssen ein Material auswählen';
	FULLNAME_E = 'Bitte geben Sie Ihren Vor- und Nachnamen ein';
	BUSINESSN_E = 'Sie sollten einen Firmennamen eingeben';
	EMAIL_E = 'Sie müssen eine E-Mail-Adresse eingeben';
	PHONE_E = 'Sie müssen eine Telefonnummer eingeben';
	ACCEPTANCE_E = 'Zustimmung zur Verarbeitung personenbezogener Daten muss akzeptiert werden';
	FORM_ID = '2304'
}

import fetchWrapper from '../../modules/fetchWrapper'
export default (Vue) => {
	new Vue({
		el: '#v-individual-form',
		props: ['formid'],
		data(){
			return {
				formState: 1,
				formData: {
					model: null,
					kind: null,
					type: null,
					side: null,
					slideWidth: null,
					slideHeight: null,
					tracksAmount: null,
					mounting: null,
					slopeHeight: null,
					slopeLength: null,
					slopeDegree: null,
					platformHeight: null,
					finish: null,
					material: null,

					option1: false,
					option2: false,
					option3: false,
					option4: false,

					description: null,
					fullname: null,
					businessName: null,
					email: null,
					phone: null,
					acceptance: false,
					attachments: null,
				},
				formFiles: [],
				formFinalData: {
					model: null,
					kind: null,
					type: null,
					side: null,
					slideWidth: null,
					slideHeight: null,
					tracksAmount: null,
					mounting: null,
					slopeHeight: null,
					platformHeight: null,
					slopeLength: null,
					slopeDegree: null,
					finish: null,
					material: null,
					option1: false,
					option2: false,
					option3: false,
					option4: false,

					description: null,
					fullname: null,
					businessName: null,
					email: null,
					phone: null,
					attachments: null,
				},
				fetchState: {
					errors: {},
					message: '',
					isLoading: false,
				}
			}
		},
		methods: {
			submit: function() {
				const [flag, errors] = this.validate();
				console.log("flaga", flag)
				if(!flag){
					// ...
					this.fetchState.errors = errors
					this.$nextTick(() => {
						console.log(document.querySelector('#error-'+Object.keys(errors)[0]), Object.keys(errors)[0])
						const errorDOM = document.querySelector('#error-'+Object.keys(errors)[0])
						if(errorDOM) errorDOM.scrollIntoView({behavior: 'smooth'});
					})
				}else{
					this.formState = 2;
					this.$nextTick(() => {
						this.transportValues();
						document.querySelector('.js-form-top').scrollIntoView({behavior: 'smooth'});
					});
				}
			},
			goToStart: function(){
				this.formState = 1;
				this.$nextTick(() => {
					document.querySelector('.js-form-top').scrollIntoView({behavior: 'smooth'});
				})
			},
			transportValues: function(){
				const formData = {...this.formData}
				if(formData['kind']) {
					formData['kind'] = document.querySelector('.js-form-kind').getAttribute('data-value-'+this.formData['kind'])
				}
				if(formData['type']) formData['type'] = document.querySelector('.js-form-type').getAttribute('data-value-'+this.formData['type'])
				if(formData['side']) formData['side'] = document.querySelector('.js-form-side').getAttribute('data-value-'+this.formData['side'])
				if(formData['material']) formData['material'] = document.querySelector('.js-form-material').getAttribute('data-value-'+this.formData['material'])
				if(formData['mounting']) formData['mounting'] = document.querySelector('.js-form-mounting').getAttribute('data-value-'+this.formData['mounting'])
				if(formData['finish']) formData['finish'] = document.querySelector('.js-form-finish').getAttribute('data-value-'+this.formData['finish'])

				this.formFinalData = formData
				this.formFinalData['attachments'] = this.formFiles[0];
				[...this.formFiles].forEach((file, index) => {
					let i = index + 1
					this.formFinalData['attachment'+ i] = file;
				});
			},
			submitFinal: async function(){
				this.fetchState.isLoading = true;
				Object.keys(this.formFinalData).forEach(x => {
					if(this.formFinalData[x] == 'null' || this.formFinalData[x] == null) this.formFinalData[x] = '';

					if(x == 'option1' || x == 'option2' || x == 'option3' || x == 'option4'){
						this.formFinalData[x] == false ? this.formFinalData[x] = "Nie" : this.formFinalData[x] = "Tak";
					}
				})

				const [status, result] = await fetchWrapper({
					url: `/wp-json/contact-form-7/v1/contact-forms/${FORM_ID}/feedback`,
					method: "POST",
					body: this.formFinalData
				});
				this.fetchState.isLoading = false;

				if(result.invalid_fields){
					this.fetchState.errors = {}
					result.invalid_fields.forEach(x => {
						this.fetchState.errors[x.error_id.replace('-ve-', '')] = x.message
					})
					this.formState = 1;
					this.$nextTick(() => {
						const errorDOM = document.querySelector('#error-'+Object.keys(this.fetchState.errors)[0])
						if(errorDOM) errorDOM.scrollIntoView({behavior: 'smooth'});
					})
				}else{
					this.fetchState.message = result.message
					this.formState = 3;
					this.$nextTick(() => {
						document.querySelector('.js-form-top').scrollIntoView({behavior: 'auto'});
					})
				}
			},

			fileChangeHandler: function(event){
				this.formFiles = event.target.files
			},

			validate: function(){
				const errors = [];
				if(!this.formData.model) errors['model'] = MODEL_E
				if(!this.formData.kind) errors['kind'] = KIND_E
				if(this.formData.model == 1){
					if(!this.formData.type) errors['type'] = TYPE_E
					if(!this.formData.side) errors['side'] = SIDE_E
					if(!this.formData.slideWidth) errors['slideWidth'] = SLIDEW_E

					if(this.formData.kind == 2 && !this.formData.tracksAmount) errors['tracksAmount'] = TRACKSA_E
				}

				if(!this.formData.slideHeight) errors['slideHeight'] = SLIDEH_E
				if(!this.formData.mounting) errors['mounting'] = MOUNTING_E
				if(this.formData.mounting == 1){
					// if(!this.formData.slopeHeight) errors['slopeHeight'] = SLOPEH_E
					// if(!this.formData.slopeLength) errors['slopeLength'] = SLOPEL_E
					// if(!this.formData.slopeDegree) errors['slopeDegree'] = SLOPED_E
				}
				if(this.formData.mounting == 2){
					// if(!this.formData.platformHeight) errors['platformHeight'] = PLATFORMH_E
				}

				if(!this.formData.finish) errors['finish'] = FINISH_E
				if(!this.formData.material) errors['material'] = MATERIAL_E

				if(!this.formData.fullname) errors['fullname'] = FULLNAME_E
				if(!this.formData.businessName) errors['businessName'] = BUSINESSN_E
				if(!this.formData.email) errors['email'] = EMAIL_E
				if(!this.formData.phone) errors['phone'] = PHONE_E
				if(!this.formData.acceptance) errors['acceptance'] = ACCEPTANCE_E

				if(Object.keys(errors).length > 0) return [false, errors];
				return [true, errors];
				// return [true, {}]
			},
		}
	})
}